import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { ApiClient } from '../common/api-client.service';

interface Account {
  id?: number,
  name: string,
}

@Component({
  templateUrl: './edit-account.component.html'
})
export class EditAccountComponent implements OnInit {
  account: Account = {name: null};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiClient: ApiClient,
  ) {}

  ngOnInit() {
    this.account.id = this.route.snapshot.params['id'];
    if ( this.account.id ) {
      this.apiClient.get<Account>(`/api/v1/accounts/${this.account.id}`).toPromise().then(a => {
        this.account = a;
      })
    }
  }

  save() {
    const save = this.account.id ?
      this.apiClient.patch<Account>(`/api/v1/accounts/${this.account.id}`, this.account) :
      this.apiClient.post<Account>('/api/v1/accounts', this.account)
    save.toPromise().then(acct => {
      // TODO success
      this.router.navigateByUrl('/');
    }, resp => {
      // TODO error
      alert(resp.error.errors);
    })
  }

  delete() {
    if ( !confirm('Are you sure you want to delete this account?') ) { return }
    this.apiClient.delete(`/api/v1/accounts/${this.account.id}`).toPromise().then(() => {
      // TODO success
      this.router.navigateByUrl('/');
    }, resp => {
      // todo error
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/accounts/edit-account.component.ts